import { Controller } from "stimulus";

export default class extends Controller {
  connect() {}

  navigateToBack() {
    if (window?.Android && typeof window.Android.onBack == "function") {
      Android.onBack();
      return;
    } else if (window.webkit && window.webkit.messageHandlers) {
      webkit.messageHandlers.performAction.postMessage({
        action: "navigateToBack",
      });
    }
  }

  navigateTo({ params }) {
    if (window?.Android && typeof window.Android.navigateTo == "function") {
      Android.navigateTo(params.url);
      return;
    } else if (window.webkit && window.webkit.messageHandlers) {
      webkit.messageHandlers.performAction.postMessage({
        action: "navigateTo",
        data: {
          url: params.url,
        },
      });
    }
  }

  showMap({ params }) {
    if (
      window?.Android &&
      typeof window.Android.onRedirectToMapFromPartner == "function"
    ) {
      Android.onRedirectToMapFromPartner(params.url);
      return;
    } else if (window.webkit && window.webkit.messageHandlers) {
      webkit.messageHandlers.performAction.postMessage({
        action: "onRedirectToMapFromPartner",
        data: {
          longitude: params.longitude,
          latitude: params.latitude,
          name: params.name,
        },
      });
    }
  }

  openMap({ params }) {
    var ua = navigator.userAgent.toLowerCase();
    var isIphone = ua.indexOf("iphone") > -1;
    var url = `google.streetview:cbll=${params.lat},${params.lng}`;
    if (window?.Android && typeof window.Android.openMap == "function") {
      Android.openMap(url);
      return;
    } else if (isIphone) {
      window.location = `http://maps.apple.com/?ll=${params.lat},${params.lng}&z=20`;
    } else {
      var url =
        "http://www.google.com/maps/place/" + params.lat + "," + params.lng;
      window.location = url;
    }
  }

  openInBrowser({ params }) {
    if (params.copy) {
      navigator.clipboard.writeText(params.copy);
    }
    if (window?.Android && typeof window.Android.openInBrowser == "function") {
      Android.openInBrowser(params.url);
      return;
    } else if (window.webkit && window.webkit.messageHandlers) {
      webkit.messageHandlers.performAction.postMessage({
        action: "openInBrowser",
        data: {
          url: params.url,
        },
      });
    }
  }

  showPartnerFromModal({ params }) {
    if (
      window?.Android &&
      typeof window.Android.showPartnerFromModal == "function"
    ) {
      Android.showPartnerFromModal(params.url);
      return;
    } else if (window.webkit && window.webkit.messageHandlers) {
      webkit.messageHandlers.performAction.postMessage({
        action: "navigateTo",
        data: {
          url: params.url,
        },
      });
    }
  }

  showCoupons({ params }) {
    if (window?.Android && typeof window.Android.showCoupons == "function") {
      Android.showCoupons(params.url);
      return;
    } else if (window.webkit && window.webkit.messageHandlers) {
      webkit.messageHandlers.performAction.postMessage({
        action: "showCoupons",
        data: {
          url: "/partner/web/partner_coupons",
        },
      });
    }
  }

  showNewsfeed({ params }) {
    if (window?.Android && typeof window.Android.showNewsfeed == "function") {
      Android.showNewsfeed(params.url);
      return;
    } else if (window.webkit && window.webkit.messageHandlers) {
      webkit.messageHandlers.performAction.postMessage({
        action: "showNewsfeed",
        data: {
          url: params.url,
        },
      });
    }
  }

  showPageAfterSubmit({ params }) {
    if (
      window?.Android &&
      typeof window.Android.showPageAfterSubmit == "function"
    ) {
      Android.showPageAfterSubmit(params.url, params.message);
      return;
    }
  }

  requireAuth() {
    console.log(window)
    if (window?.Android && typeof window.Android.requireAuth == "function") {
      Android.requireAuth();
      return;
    } else if (window.webkit && window.webkit.messageHandlers) {
      webkit.messageHandlers.performAction.postMessage({
        action: "requireAuth",
      });
    } else {
      document.querySelector("auth-frame").classList.remove("hidden");
    }
  }

  openFile({ params }) {
    if (window?.Android && typeof window.Android.openFile == "function") {
      Android.openFile(params.url, params.type);
      return;
    } else if (window.webkit && window.webkit.messageHandlers) {
      webkit.messageHandlers.performAction.postMessage({
        action: "openFile",
        data: {
          url: params.url,
          fileType: params.type,
        },
      });
    }
  }

  callTo({ params }) {
    if (window?.Android && typeof window.Android.callTo == "function") {
      Android.callTo(params.number);
      return null;
    } else if (window.webkit && window.webkit.messageHandlers) {
      webkit.messageHandlers.performAction.postMessage({
        action: "callTo",
        data: {
          number: params.number,
        },
      });
    }
  }

  logout() {
    if (window?.Android && typeof window.Android.logOut == "function") {
      Android.logOut();
      return null;
    } else if (window.webkit && window.webkit.messageHandlers) {
      webkit.messageHandlers.performAction.postMessage({
        action: "logout",
      });
    }
  }

  openPartnersTab({ params }) {
    if (window?.Android && typeof window.Android.seeAllPartners == "function") {
      Android.seeAllPartners(params.value);
      return null;
    } else if (window.webkit && window.webkit.messageHandlers) {
      webkit.messageHandlers.performAction.postMessage({
        action: "partnerList",
        data: {
          order: params.value,
        },
      });
    }
  }

  openNewsTab() {
    if (window?.Android && typeof window.Android.seeAllNews == "function") {
      Android.seeAllNews();
      return null;
    } else if (window.webkit && window.webkit.messageHandlers) {
      webkit.messageHandlers.performAction.postMessage({
        action: "newsList",
      });
    }
  }

  openNewsDetail({ params }) {
    if (window?.Android && typeof window.Android.seeNewsDetail == "function") {
      Android.seeNewsDetail(params.partialurl);
      return null;
    } else if (window.webkit && window.webkit.messageHandlers) {
      webkit.messageHandlers.performAction.postMessage({
        action: "navigateTo",
        data: {
          url: params.partialurl,
        },
      });
    }
  }

  filterCategory({ params }) {
    if (window?.Android && typeof window.Android.filterCategory == "function") {
      Android.filterCategory(`${params.type}-${params.value}`);
      return null;
    } else if (window.webkit && window.webkit.messageHandlers) {
      webkit.messageHandlers.performAction.postMessage({
        action: "partnerList",
        data: {
          filters: [`${params.type}-${params.value}`],
        },
      });
    }
  }

  openWinzone({ params }) {
    if (window?.Android && typeof window.Android.navigateTo == "function") {
      Android.navigateTo(params.url);
      return;
    } else if (window.webkit && window.webkit.messageHandlers) {
      webkit.messageHandlers.performAction.postMessage({
        action: "navigateTo",
        data: {
          url: params.url,
        },
      });
    } else {
      window.location.href = params.url;
    }
  }

  copyToClipBoard(e) {
    const text = e.target.innerText;
    navigator.clipboard.writeText(text);
  }
}
